import { AppRoutes } from '../../../Core/App/AppRoutes';
import { AppRouteType } from '../../Components/Templates/AppRouter/AppRouteType';
import { PrivateRoute } from '../../Components/Templates/AppRouter/PrivateRoute';
import { LoadableMessagePage } from '../../Pages/Message/LoadableMessagePage';

const getMessageRoute = (props: object): AppRouteType => ({
    id: AppRoutes.MESSAGE,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.MESSAGE,
        component: LoadableMessagePage,
        ...props,
    },
});

export const getMessageRoutes = (args: object) => [getMessageRoute(args)];
